'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ErrorStyled = styled__default["default"].div.withConfig({
  componentId: "sc-1agrnkn-0"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    border: '1px solid #e02020',
    borderRadius: '4px',
    background: '#ffeded',
    boxSizing: 'border-box',
    padding: '1rem',
    ...s
  };
});
const ErrorBannerC = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(ErrorStyled, {
    role: "status",
    s: bodytextDefaultNone
  }, children);
};
var ErrorBanner = nthHookTheme.withThemeProvider(ErrorBannerC, {
  themeTokens: ['bodytextDefaultNone']
});

exports["default"] = ErrorBanner;
